import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem, Icon } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, ProgressBar } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait1 from './svg/wait1.svg'
import svgWait2 from './svg/wait2.gif'

import { SystemHeader } from './CommonUI';
import i18next from 'i18next';
import {CBBCTranInfo,  StkCodeInfo, CurrencyInfo ,CBBCConfig} from './Types' 

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

interface PageInfo {
    n: number
}

interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}


var GsbFlag: any;


interface CBBCProcessMainProps {
    gsb: AxiosInstance,
    currentTranAC?: CBBCTranInfo,
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function CBBCProcessMain({ gsb }: CBBCProcessMainProps) {

    let ProgressId2 = ""
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    
    const { t, i18n } = useTranslation();

    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)
    const [taskList, setTaskList] = useState([] as TaskInfo[])
    const [showTasks, setShowTasks] = useState(false)
    const [DataFormatValue, setDataFormatValue] = useState(false)
 
    const [MoblieDev, setMoblieDev] = useState(false)
    const [searchLimit, setSearchLimit] = useState(25)
    const [searchBackward, setSearchBackward] = useState(false)    
    const [selectedTabId, setSelectedTabId] = useState("list")
     

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [RptLogName, setRptLogName] = useState("")
    const [ShowWait, setShowWait] = useState(false)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(false)
 
    const [s_ClCode1, sets_ClCode1] = useState("")
    const [s_ClCode2, sets_ClCode2] = useState("")
 
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    //const [cPrintMode, setcPrintMode] = useState("PS")

    const [LineLimit, setLineLimit] = useState(54 - 7)

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [bankAc,setbankAc] = useState({} as CBBCTranInfo)

    const [StkNoValue, setStkNoValue] = useState(bankAc.d_StkNo)
    const [Caretdown2, setCaretdown2] = useState(false)
    const [StkCodeList, setStkCodeList] = useState([] as StkCodeInfo[])
    const [StkCodeValue, setStkCodeValue] = useState(bankAc.d_Stk)
    const [StkNameValue, setStkNameValue] = useState(bankAc.d_StkName)
    const [CCASSStockValue, setCCASSStockValue] = useState(false)
    const [StkTypeValue,setStkTypeValue] = useState(bankAc.d_StkType)
    const [StkLotSizeValue,setStkLotSizeValue] = useState(bankAc.d_LotSize)
    const [StkExpiryDateValue,setStkExpiryDateValue] = useState(bankAc.d_ExpiryDate)
    
    //const [configData, setConfigData] = useState({} as sbConfig)
    const [CBBCConfig, setCBBCConfig] = useState({} as CBBCConfig)
    const [data, setData] = useState({} as CBBCConfig)

    
    const [def_d_NoOfClient,setdef_d_NoOfClient] = useState("0")
 
    const [def_d_ResidualValue,setdef_d_ResidualValue] = useState("0.00")
    const [def_d_HandlingFee,setdef_d_HandlingFee] = useState("0.00")
    const [def_d_MINHAND,setdef_d_MINHAND] = useState("0.00")
    const [def_d_MAXHAND,setdef_d_MAXHAND] = useState("0.00")     
    const [def_d_CAFEE,setdef_d_CAFEE] = useState("0.00")      
    const [def_d_CAMINFEE,setdef_d_CAMINFEE] = useState("0.00")      
    const [def_d_CAMAXFEE,setdef_d_CAMAXFEE] = useState("0.00")      
    const [def_d_Reason,setdef_d_Reason]   =  useState("")

    const [def_d_BSTKWDF, setdef_d_BSTKWDF] = useState("0")
    const [def_d_BPRF, setdef_d_BPRF] = useState("0")

    const [isNew,setisNew] = useState(true)

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<CBBCTranInfo>()

    const [stockfound ,setstocfound] = useState(false)
    //Calculate Stamp Amount

    const [IsCalStmpAmount, setIsCalstmpAmount] = useState("N")

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        //register({ name: "d_Dividend_Currency" })
    }, [register])

   useEffect(() => {

   
        (async () => {
            try {
                const res1 = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "CBBCConfig",
                        cAction: "ListRec",
                    });
             
                if (res1.data.data.length > 0) {
                    
                  
                    setIsCalstmpAmount(res1.data.data[0].x_CAL_STM)
                }
 
             

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [ ])


    useEffect(() => {
        (async () => {
            try {
              
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: StkNoValue})   
                 

                if ( res.data.count > 0 )
                {
                    setStkCodeValue(res.data.data[0].d_StkCode)
                    setStkNameValue(res.data.data[0].d_StkName)
                    //setCCASSStockValue(res.data.data[0].d_CcassStk==="Y")

                    setStkTypeValue(res.data.data[0].d_StkType)
                    setStkLotSizeValue(res.data.data[0].d_LotSize)
                    setStkExpiryDateValue(res.data.data[0].d_ExpiryDate)
                    //setShowOK(true)
                    setstocfound(true)
 
                    if (StkTypeValue==="W")
                    {
                        setdef_d_Reason("WARRANT")
                    }
                    else if (StkTypeValue ==="C")
                    {
                        setdef_d_Reason("CBBC")
                    }
                    else
                    {
                        setdef_d_Reason("PRIVATISATION")
                    }
                    const res2 = await gsb.post('/CBBC',
                        {   sb_data: {
                              d_StkNo:StkNoValue 
                            },
                            cPgmId: "CBBCCallMgnt",
                            cAction: "GetRec",
                        });
                   // console.log(res2.data.data)
                   // setCBBCConfig(res2.data.data) will sbe slow , sometime undeifne...
                    if (res2.data.ok == true)
                    {
              

                        setdef_d_ResidualValue(utils.numToString3(res2.data.data.ResidualValue))
                        // setdef_d_HandlingFee(utils.numToString3(res2.data.data.x_CB_HAND,2)) 
                        setdef_d_HandlingFee(utils.numToString3(res2.data.data.x_CB_HAND, 2)) 

                        setdef_d_HandlingFee(utils.numToString3(res2.data.data.x_CB_HAND,2)) 
                        setdef_d_MINHAND(utils.numToString3(res2.data.data.x_CB_MINHAND,2)) 
                        setdef_d_MAXHAND(utils.numToString3(res2.data.data.x_CB_MAXHAND,2)) 

                        setdef_d_CAFEE(utils.numToString3(res2.data.data.x_CBBC_CAFEE,2)) 
                        setdef_d_CAMINFEE(utils.numToString3(res2.data.data.x_CBBC_MINFEE,2)) 
                        setdef_d_CAMAXFEE(utils.numToString3(res2.data.data.x_CBBC_MAXFEE,2))      
                        setdef_d_NoOfClient((res2.data.data.NOCLIENT))       
                       // setdef_d_NoOfClient((CBBCConfig.NOCLIENT)) -> response slow     
                
                        setdef_d_BSTKWDF(res2.data.data.BSTKWDF)
                        setdef_d_BPRF(res2.data.data.BPRF)
                        //console.log(def_d_CAFEE)
                     }
                     setIsCalstmpAmount(CBBCConfig.x_CAL_STM)
                    
                } else { 

                    const res2 = await gsb.post('/CBBC',
                        {
                            sb_data: {
                                d_StkNo: StkNoValue
                            },
                            cPgmId: "CBBCCallMgnt",
                            cAction: "GetRec",
                        });
                    setCBBCConfig(res2.data.data) 
                    setdef_d_ResidualValue(utils.numToString3(res2.data.data.ResidualValue))
                    // setdef_d_HandlingFee(utils.numToString3(res2.data.data.x_CB_HAND,2)) 
                    setdef_d_HandlingFee(utils.numToString3(res2.data.data.x_CB_HAND, 2))

                    setdef_d_HandlingFee(utils.numToString3(res2.data.data.x_CB_HAND, 2))
                    setdef_d_MINHAND(utils.numToString3(res2.data.data.x_CB_MINHAND, 2))
                    setdef_d_MAXHAND(utils.numToString3(res2.data.data.x_CB_MINHAND, 2))

                    setdef_d_CAFEE(utils.numToString3(res2.data.data.x_CBBC_CAFEE, 2))
                    setdef_d_CAMINFEE(utils.numToString3(res2.data.data.x_CBBC_MINFEE, 2))
                    setdef_d_CAMAXFEE(utils.numToString3(res2.data.data.x_CBBC_MAXFEE, 2))
                    setdef_d_NoOfClient((res2.data.data.NOCLIENT))
                    // setdef_d_NoOfClient((CBBCConfig.NOCLIENT)) -> response slow     

                    setdef_d_BSTKWDF(res2.data.data.BSTKWDF)
                    setdef_d_BPRF(res2.data.data.BPRF)              
                  
                    setdef_d_Reason(" ")
                    
                    //clear stock info
                    if (StkNoValue.length > 0)
                    {
                        setStkCodeValue("stock no found")
                        setStkNameValue(" ") 
                    }

                    /*
                    setStkCodeValue("")
                    setStkNameValue("") 
                    setStkLotSizeValue("0")
                    setdef_d_ResidualValue("0")
                    setdef_d_HandlingFee("0.00")
                    setdef_d_MINHAND("0.00")
                    setdef_d_MAXHAND("0.00")
                    setdef_d_CAFEE("0.00")
                    setdef_d_CAMINFEE("0.00")
                    setdef_d_CAMAXFEE("0.00")
                    */
                   // setdef_d_NoOfClient("0")
                    // showError("error stock not found")

                }
                
            } catch (error) {
                
                 showErrorBox(error)
                console.log(error)
            }
        })()
    }, [gsb, StkNoValue]) 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                //console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setCSVFormat(GsbFlag.CSVFormat) ;
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        if (taskList.findIndex((t: TaskInfo) => t.status === 0) > -1) {
            //console.log("running task(s) found, refresh tasklist in 1s")
            setTimeout(async () => {
                try {
                    const res = await gsb.post('/tasklist', taskList.map((t) => t.id));
                    //console.log("tasklist res.data.data", res.data.data)
                    setTaskList(res.data.data)
                } catch (error) {
                    utils.showError(error)
                }
            }, 3*1000)
        } else {
            //console.log("all task(s) completed.")
        }
    }, [taskList, gsb])

    useEffect(() => {
        //setShowRpt(false)
        //setShowNoRecord(false)
        //console.log("stockfound",stockfound)
        if (stockfound ===true)
        {
            setShowOK(true)
        }
        else
        {
            setShowOK(false)
        }
        
    }, [StkNameValue]) 

    useEffect(() => {
        const refreshTasks = async () => {
            ProgressId2 = ProgressId
            if ( ProgressId2.trim().length > 0 ) {
                try {
                    const res = await gsb.post('/Progresslist', {p_data: ProgressId2})
                    let pValue = 0
                    if ( res.data.count > 0 ) {
                        if ( res.data.data[0].id === ProgressId2 ) {
                            pValue = res.data.data[0].progressValue / res.data.data[0].progressMax 
                            setProgressValue(pValue)
                        }
                        if (res.data.data[0].status > 0 ) {
                            clearInterval(timer)
                        }
                    }
                } catch (error) {
                    utils.showError(error)
                }
            }
        }
        let timer = setInterval(refreshTasks, 20*1000)
        return () => {clearInterval(timer)}
    }, [gsb, ProgressId, nPage])

    useEffect(() => {
        if ( RptName !== "" ) {
            document.getElementById("_rptlink")?.click()
            window.scrollTo(0, document.body.scrollHeight)
        }
    }, [RptName]) 
    
    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        setShowWait(true)
        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")
        setRptLogName("")

        setnPage(1)
        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)

        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                //console.log("CBBCGenMain onsubmit called", data)
                ProgressId2 = utils.genUUID()
                setProgressId("")
                
                    const res = await gsb.post('/CBBC',
                    {   sb_data:{  
                        ProgressId:ProgressId2,
                        DataFormat : DataFormatValue,                                            
                        s_StkNo1:StkNoValue,   
                        s_Stk : StkNameValue,
                        s_ResidualValue: utils.StringToNum2(def_d_ResidualValue),
                        s_HandlingFee: utils.StringToNum2(def_d_HandlingFee),
                        s_MINHAND: utils.StringToNum2(def_d_MINHAND),
                        s_MAXHAND: utils.StringToNum2(def_d_MAXHAND),
                        s_CAFEE: utils.StringToNum2(def_d_CAFEE),
                        s_CAMINFEE: utils.StringToNum2(def_d_CAMINFEE),
                        s_CAMAXCEE: utils.StringToNum2(def_d_CAMAXFEE),
                        s_Reason: def_d_Reason,
                        IsCalstmpAmount: IsCalStmpAmount,
                        nPage: 1,
                        cPrintMode: "PS",
                        limit: LineLimit,
                        },
                    cPgmId: "CBBCCallMgnt",
                    cAction: "CBBCProcess"
                
                    });

                console.log("CBBCProcess res.data.data: ", res.data.data) 
                if ( res.data.count > 0 ) {
                    setRstdata2([])
                    for (let j = 0; j < res.data.Rptdata.length; j++) {
                        Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                    }
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)
                    setRstdata(Rstdata2)
                    //console.log("Rstdata: ", Rstdata) 
                    setRptHead1(res.data.Rpthead1)
                    setRptName(res.data.RptName)
                    setRptLogName(res.data.RptLogName)
                    setRptNameNo(res.data.RptNameNo)
                    //console.log("RptName: ", RptName) 
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(res.data.TotalPageNo)
                        for ( let j = 1; j <= res.data.TotalPageNo; j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRpt(false)
                }
            } catch (error) {
               utils.showError(error)
            }
        })()
    }
 
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

 

    
    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>

  
     let Process_Status = <>
            <div className="Spacing-V-16" />
            <div className="Row">
                <h4 className="Col-1-6">Processing Status</h4>
            </div>
 {/*
            <div className="Row">               
                <InputGroup className="Col-1-6"  readOnly value="CBBC Stock Withdrawal" />
                <InputGroup className="Col-7-2"  readOnly value={def_d_BSTKWDF.trim()} />
                <InputGroup className="Col-1-6"  readOnly value="P/R Tran Generate" />
                <InputGroup className="Col-7-2" readOnly value={def_d_BPRF.trim()} />           
            </div>

*/}
            <div className="Row">
                <InputGroup className="Col-1-6" readOnly value="CBBC Stock Withdrawal" />               
             {def_d_BSTKWDF === "2" && <InputGroup className="Col-7-2" leftIcon="tick" />}    
             {def_d_BSTKWDF === "0" && <InputGroup className="Col-7-2" leftIcon="cross" />}    
             {def_d_BSTKWDF === "1" && <InputGroup className="Col-7-2" leftIcon="cross" />}                          
                <InputGroup className="Col-1-6" readOnly value="P/R Tran Generate" />
             {def_d_BPRF === "2" && <InputGroup className="Col-7-2" leftIcon="tick" /> }
             {def_d_BPRF === "0" && <InputGroup className="Col-7-2" leftIcon="cross" />}    
             {def_d_BPRF === "1" && <InputGroup className="Col-7-2" leftIcon="cross" />}                            
            </div>


      </>

     let list1 = <>
         <div className="Spacing-V-16" />
         {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download</a>}
         &nbsp; &nbsp; {RptLogName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>}
         {/*ShowRpt && ! DataFormatValue && Pagination*/}
         {ShowRpt && ! DataFormatValue}         
         {/* display search list */}
      
 
         <HTMLTable striped interactive condensed>
             <thead id="rpt_th_r">
                 <tr >
                     { ! DataFormatValue && <th className="RCol-Head_p">
                             {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download</a>}
                         </th>
                     }
                 </tr>                    
                 <tr>
                     <td className="RCol-Head1">{RptHead1}</td>
                 </tr>                    
             </thead>
             <tbody id="rpt_tr">
                 {Rstdata.map((rpt, i) =>
                     <tr key={i} onDoubleClick={() => { }}>
                         <td className="RCol-Rpt" onClick={() => {  }}>{rpt.Rst_Line}</td>
                     </tr>
                 )}
             </tbody>
             <div className="Spacing-V-16" />
             {/*ShowRpt && ! DataFormatValue && Pagination*/}
             {ShowRpt && ! DataFormatValue}
         </HTMLTable>
     </>

     {/*if (! ("d_StkCodeNO" in IPO)) return null*/}
    const handleValueChange = (value: string) => {
        //console.log('Formatted value:', value);
        setdef_d_HandlingFee(value)
    };
 
     let RptNameaRef = <>
     { /*RptNameNo > 0 && <div>  &nbsp;
         {aRptNameNo.map((no, j) => 
             <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
         )}
     </div>*/ }
     { RptNameNo <= 0 && <a id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>}
     </>
     let list = <>
     <div className="Spacing-V-8" />
     {/* {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>} */}
     {/*RptName.trim().length > 0 && RptNameaRef*/}
     {/*ShowRpt && ! DataFormatValue && Pagination*/}
     {/* display search list */}
     <HTMLTable striped interactive condensed>
         <thead id="rpt_th_r">
             <tr >
                 { ! DataFormatValue && <th className="RCol-Head_p">
                     {/*RptName.trim().length > 0 && RptNameaRef*/}
                 </th>
                 }
             </tr>                    
             <tr>
                 <td className="RCol-Head1">{"CBBC Result:"}</td>
             </tr>                    
         </thead>
         <tbody id="rpt_tr">
             {Rstdata.map((rpt, i) =>
                 <tr key={i} >
                     <td className="RCol-Rpt" >{rpt.Rst_Line}</td>
                 </tr>
             )}
         </tbody>
         <div className="Spacing-V-16" />
         {/*ShowRpt && ! DataFormatValue && Pagination*/}
     </HTMLTable>
     </>


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Select CBBC for Prcoessing</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* <Button className="Col-1-2"  intent={Intent.SUCCESS} icon="print">Process CBBC</Button>
                       <Button className="Col-3-2"   icon="print">Print CBBC</Button>
                        <Button className="Col-5-2"  icon="edit"> WITHDRAWAL  CBBC</Button>
                        <Button className="Col-7-2"  icon="edit">DEPOSIT  CBBC RESIDUAL</Button>    */}
                    </div>  
                    <div className="Spacing-V-16" />                                    
                    <div className="Row">

           
                        <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                            <InputGroup disabled={! isNew} id="inputStkNo" name ="d_StkNo" value={StkNoValue} autoFocus={isNew} defaultValue="" placeholder="Stock No. ..." onChange={utils.handleStringChange(s => setStkNoValue(s)) } inputRef={register({ required: true}) } />
                            {errors.d_StkNo && errors.d_StkNo.types && <span id="Err_msg">{errors.d_StkNo.types.message}</span>}                                
                        </FormGroup>    
                        <FormGroup className="Col-2-2" label="Stock Code / Name" labelFor="inputStkName">
                            <div>
                            <div id="DispText">{StkCodeValue}</div>
                            <div id="DispText">{StkNameValue}</div>
                            </div>
                        </FormGroup>

                       <FormGroup className="Col-1-2" label="Expiry Date" labelFor="inputExpiryDate"  >                            
                            <InputGroup id="inputExpiryDate" readOnly  value={(StkExpiryDateValue)}   />                                
                        </FormGroup> 
                        <FormGroup className="Col-1-2" label="Lot Size" labelFor="inputLotSize"  >                            
                            <InputGroup id="inputLotSize" readOnly  value={(StkLotSizeValue)}   />                                
                        </FormGroup> 
                        
                        <FormGroup className="Col-3-2" label="Type" labelFor="inputStkType"  >
                            <InputGroup id="inputStkType" readOnly value={(StkTypeValue)} />
                        </FormGroup> 

                        <FormGroup className="Col-1-2" label="Residual Value." labelFor="inputResidual" labelInfo="*">
                            
                            <InputGroup id="inputd_ResidVal" name="d_ResidualValue" value={(def_d_ResidualValue)} onChange={utils.handleStringChange(s => setdef_d_ResidualValue(s)) }   />
                            {errors.d_ResidVal && errors.d_ResidVal.types && <span id="Err_msg">{errors.d_ResidVal.types.message}</span>}                                
                        </FormGroup> 
                        <FormGroup className="Col-3-2" label="No of Client" labelFor="inputNoOfClient" labelInfo="*">                            
                            <InputGroup id="inputNoOfClient" name="d_NoOfClient" readOnly value={(def_d_NoOfClient.trim())} onChange={utils.handleStringChange(s => setdef_d_NoOfClient(s)) }   />                                                       
                        </FormGroup> 

                        <FormGroup className="Col-1-2" label="Handling Fee." labelFor="inputHandling" labelInfo="*">
                            <InputGroup id="inputd_ResidVal" name="d_HandlingFee"  value={(def_d_HandlingFee)}   onChange={(utils.handleStringChange(s => setdef_d_HandlingFee(s))) }  />
                        </FormGroup> 
         
                        <FormGroup className="Col-3-2" label="Minimum Handling Fee." labelFor="inputMINHAND" labelInfo="*">
                            <InputGroup   name="d_MINHAND"  value={ (def_d_MINHAND)}   onChange={(utils.handleStringChange(s => setdef_d_MINHAND(s))) }  />
                        </FormGroup>        
                        <FormGroup className="Col-5-2" label="Maximum Handling Fee." labelFor="inputMAXHAND" labelInfo="*">
                            <InputGroup   name="d_MAXHAND" value={ (def_d_MAXHAND )}   onChange={(utils.handleStringChange(s => setdef_d_MAXHAND(s))) }  />
                        </FormGroup>     
        
                        <FormGroup className="Col-1-2" label="CA Fee." labelFor="inputCAFEE" labelInfo="*">
                            <InputGroup   name="d_CAFEE"  value={ (def_d_CAFEE )}   onChange={(utils.handleStringChange(s => setdef_d_CAFEE(s))) }  />
                        </FormGroup>       
                        <FormGroup className="Col-3-2" label="Minimum CA Fee." labelFor="inputCAMINCAFEE" labelInfo="*">
                            <InputGroup   name="d_CAMINFEE"  value={(def_d_CAMINFEE)}   onChange={(utils.handleStringChange(s => setdef_d_CAMINFEE(s))) }  />
                        </FormGroup>        
                        <FormGroup className="Col-5-2" label="Maximum CA Fee." labelFor="inputdCAMAXCAFEE" labelInfo="*">
                            <InputGroup  name="d_CAMAXFEE"   value={(def_d_CAMAXFEE)}   onChange={(utils.handleStringChange(s => setdef_d_CAMAXFEE(s))) }  />
                        </FormGroup>  
                     {/*
                        <FormGroup className="Col-1-3" label="Select Simplified Chinese on Statement" labelFor="Inputd_StmtSimplifiedChiese">
                            <RadioGroup
                                name="d_StmtSimplifiedChiese"
                                inline={true}
                                selectedValue={def_d_StmtSimplifiedChiese}
                                onChange={utils.handleStringChange(s => setdef_d_StmtSimplifiedChiese(s)) }
                                ref={register}>
                                <Radio label="Yes" value="Y" />
                                <Radio label="No"  value="N" />
                            </RadioGroup>
                            {errors.d_StmtSimplifiedChiese && errors.d_StmtSimplifiedChiese.types && <span id="Err_msg">{errors.d_StmtSimplifiedChiese.types.message}</span>}
                        </FormGroup>
                     */}
                        <FormGroup className="Col-1-2" label="Calualte Stamp Amount"  >                          
                            <RadioGroup
                                name="d_IsCalSmpAmount"                                
                                inline={true}
                                selectedValue={IsCalStmpAmount}
                                onChange={utils.handleStringChange(s => setIsCalstmpAmount(s))}
                                ref={register}>
                                <Radio value="Y">Yes</Radio>
                                <Radio value="N">No</Radio>
                                </RadioGroup>
                        </FormGroup>    
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-2" >
                            <div>  Reason : {def_d_Reason}</div>
                        </FormGroup>
           
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-2" >
                            <div> {Process_Status}</div>
                        </FormGroup>

                    </div>                    
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-2" >
                            <div>CBBC for Processing</div>
                        </FormGroup>
                    </div>
                    <div className="Row">                        
                         <Button className="Col-1-1"  type="submit">OK</Button>                         
                    </div>
                </Card>
                {/*
                {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div> }
                {ShowNoRecord && <p>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-3"  >
                            <span id="Err_msg">No Record found !!!</span>
                        </FormGroup>
                    </div>
                </p>
                }
                {ShowRpt && list}*/}
 
                {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div> }
                {ShowNoRecord && <p>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-3"  >
                            <span id="Err_msg">No Record found !!!</span>
                        </FormGroup>
                    </div>
                </p>
                }
                {  list}

  

            </form>
        </>
    );
}

export default CBBCProcessMain